import { Progress, Table, StatusWarning, StatusError, StatusOK } from '@backstage/core-components';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import '../../../api/DevToolsApi.esm.js';
import '@backstage/errors';
import '@backstage/core-plugin-api';
import 'react-use/esm/useAsync';
import { useExternalDependencies } from '../../../hooks/useExternalDependencies.esm.js';

const useStyles = makeStyles(
  (theme) => createStyles({
    paperStyle: {
      padding: theme.spacing(2)
    }
  })
);
const getExternalDependencyStatus = (result) => {
  switch (result?.status) {
    case "Healthy":
      return /* @__PURE__ */ React.createElement(Typography, { component: "span" }, /* @__PURE__ */ React.createElement(StatusOK, null), " ", result.status);
    case "Unhealthy":
      return /* @__PURE__ */ React.createElement(Typography, { component: "span" }, /* @__PURE__ */ React.createElement(StatusError, null), " ", `${result.status}`);
    case void 0:
    default:
      return /* @__PURE__ */ React.createElement(Typography, { component: "span" }, /* @__PURE__ */ React.createElement(StatusWarning, null), " Unknown");
  }
};
const columns = [
  {
    title: "Name",
    width: "auto",
    field: "name"
  },
  {
    title: "Target",
    width: "auto",
    field: "target"
  },
  {
    title: "Type",
    width: "auto",
    field: "type"
  },
  {
    title: "Status",
    width: "auto",
    render: (row) => /* @__PURE__ */ React.createElement(Grid, { container: true, direction: "column" }, /* @__PURE__ */ React.createElement(Grid, { item: true }, /* @__PURE__ */ React.createElement(Typography, { variant: "button" }, getExternalDependencyStatus(row))), /* @__PURE__ */ React.createElement(Grid, { item: true }, row.error && /* @__PURE__ */ React.createElement(Typography, null, row.error)))
  }
];
const ExternalDependenciesContent = () => {
  const classes = useStyles();
  const { externalDependencies, loading, error } = useExternalDependencies();
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error" }, error.message);
  }
  if (!externalDependencies || externalDependencies.length === 0) {
    return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Paper, { className: classes.paperStyle }, /* @__PURE__ */ React.createElement(Typography, null, "No external dependencies found")));
  }
  return /* @__PURE__ */ React.createElement(
    Table,
    {
      title: "Status",
      options: {
        paging: true,
        pageSize: 20,
        pageSizeOptions: [20, 50, 100],
        loadingType: "linear",
        showEmptyDataSourceMessage: !loading
      },
      columns,
      data: externalDependencies || []
    }
  );
};

export { ExternalDependenciesContent, getExternalDependencyStatus };
//# sourceMappingURL=ExternalDependenciesContent.esm.js.map
